import { errorLogger } from "@/Common/helpers/logger";
import { useAuthorization } from "@/Common/hooks/Authorization/Authorization";
import actions from "@/Constants/actionsList";
import SimpleTextField from "@/Layouts/components/InputComponents/SimpleTextField";
import { updateSystemSettings } from "@/Settings/api/SystemSettings/mutations";
import { ISystemSettings } from "@/Settings/types/Common/model";
import { Grid } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

type MaxPTOProps = { locationId: string; maxAllowableBorrowedPTO?: number };

const MaxPTO = (props: MaxPTOProps) => {
	const { locationId, maxAllowableBorrowedPTO = "" } = props;
	const [error, setError] = useState(false);
	const { useAuth } = useAuthorization();
	const maxAllowableBorrowedPTOAction = useAuth(actions.EDIT_MAX_ALLOWABLE_BORROWED_PTO);
	const queryClient = useQueryClient();

	const { mutate: updatePTO, isPending } = useMutation({
		mutationFn: (input: number) => updateSystemSettings(locationId, { maxAllowableBorrowedPTO: input }, "MaxPTO"),
		onSuccess: (res: ISystemSettings) => {
			queryClient.setQueryData(["systemSettings", locationId], (oldData: ISystemSettings) => {
				return { ...oldData, maxAllowableBorrowedPTO: res.maxAllowableBorrowedPTO };
			});
		},
		onError: (err) => errorLogger(err),
	});

	const onActionUpdate = (input: string) => {
		if (input) {
			updatePTO(Number(input));
			setError(false);
		} else {
			setError(true);
		}
	};

	return (
		<Grid container direction="row" className="!mt-[16px]">
			<Grid item className="position-mapping-payroll-column">
				<SimpleTextField
					editable
					outlined
					text={String(maxAllowableBorrowedPTO)}
					placeholder="Balance"
					error={error}
					onActionUpdate={onActionUpdate}
					onlyNumbers
					disabled={!maxAllowableBorrowedPTOAction || isPending}
					sx={{ width: "150px" }}
				/>
			</Grid>
		</Grid>
	);
};

export default MaxPTO;
